<template>
  <!-- https://shimo.im/docs/YpYvW9pCxdpD6K8K/read -->
  <modal
    title="服务介绍"
    :show="value"
    @close="$emit('input', false)"
    :buttons="buttons"
    :autoHeight="true"
    class="qingsu-rule-modal-container"
  >
    <modelScroll class="txt-container">
      <div v-html="parseRule" v-if="rule"></div>
      <template v-else>
        <p>
          大年初一，<b>壹心理发起「后背」计划，为疫区提供免费、专业且系统的心理援助</b>，让心理人做一次逆行者的后背。目前从2000名咨询师+志愿者里面，筛选出有专业背景和重大危机处理经验的{{
            supportTeacher
          }}名心理咨询师上线接听公益专线。
        </p>
        <br />
        <p class="subtitle">
          「公益专线」服务内容：
        </p>
        <p>
          壹心理疫期公益专线是一个在线心理倾诉和援助系统，主要为疫区同胞通过语音电话提供情绪疏导服务。
        </p>

        <br />
        <p class="subtitle">「公益专线」服务对象：</p>
        <p>被疫情影响的一线医护人员、病患家属、以及大众用户完全免费使用。</p>

        <br />
        <p class="subtitle">「公益专线」服务时间：</p>
        <p>
          每次<b>25分钟以上</b>，每日<b>9:00AM--22:00PM</b>，从即日起至3月20号。
        </p>
      </template>
    </modelScroll>
  </modal>
</template>

<script>
import modal from 'lib/component/vue/upModel/upModel.vue'
import modelScroll from 'lib/component/vue/modelScroll/modelScroll.vue'
export default {
  components: {
    modal,
    modelScroll
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    buttons: {
      type: Array,
      default() {
        return [
          {
            label: '知道了',
            color: '#ff745b'
          }
        ]
      }
    },
    rule: {
      type: String
    },
    supportTeacher: {
      type: Number,
      default: 120
    }
  },
  computed: {
    parseRule() {
      if (!this.rule) return ''
      return this.rule.replace(/\r\n/g, '<br/>')
    }
  }
}
</script>

<style lang="scss">
.qingsu-rule-modal-container {
  .txt-container {
    // height: 58vh;
    padding: 30px 40px;
    margin: 30px 0;
    font-size: 28px;
    color: #666;
    flex: 1;
    line-height: 1.5;
    overflow: hidden;
    overflow-y: scroll;

    .subtitle {
      margin-bottom: 10px;
      // font-size: 32px;
      font-size: 28px;
      font-weight: bold;
      color: #333;
    }

    .strong {
      font-weight: bold;
      text-decoration: underline;
      // color: #333;
    }

    .third-title {
      font-size: 32px;
      font-weight: bold;
      // color: #333;
    }

    .date {
      margin-top: 30px;
      text-align: right;
    }
  }

  .common-model-up-btn {
    font-size: 32px !important;
  }
}
</style>
